// note: general import
import Axios from "axios";
import Cookies from "universal-cookie";

// note: utils import
import { getAccessCookie, setAccessCookie } from "utils/cookies";

const cookies = new Cookies(null, {
  path: "/",
});

// note: create token service.
export function createTokenService({ baseURL, onLogout }) {
  // note: minimal axios just for refresh endpoint.
  const refreshClient = Axios.create({
    baseURL:
      baseURL !== process.env.REACT_APP_TENANT_BE
        ? process.env.REACT_APP_TENANT_BE
        : baseURL,
    withCredentials: true,
  });

  // note: shared refresh state.
  let refreshPromise = null;

  // note: get access token.
  function getAccessToken() {
    return cookies.get("token")?.token || null;
  }

  // note: set tokens
  function setTokens({
    token,
    expiryToken,
    // note: the script does not use temporarily.
    refreshToken,
    expiryRefreshToken,
  }) {
    setAccessCookie("token", JSON.stringify({ token }), {
      expires: new Date(Date.now() + (Number(expiryToken) || 3600000)), // note: coerce; expiryToken arrives as string -> "+" concatenates -> Invalid Date -> "option expires is invalid"
    });

    // note: set new refresh token. the script does not use temporarily
    // setAccessCookie(
    //   "refreshToken",
    //   JSON.stringify({ refreshToken }),
    //   {
    //     maxAge: expiryRefreshToken,
    //     domain: process.env.REACT_APP_COOKIE_DOMAIN,
    //   }
    // );
  }

  // note: de refresh request.
  async function doRefreshRequest() {
    // note: wrap refresh in a timeout so it can’t hang forever
    const timeout = new Promise((_, reject) => {
      const id = setTimeout(() => {
        clearTimeout(id);
        reject(new Error("Refresh request timeout"));
      }, 10_000); // note: 10s fuse (tunable)
    });

    const call = (async () => {
      // note: the script does not use temporarily.
      // note: hit end-point service via reques body.

      // const res = await refreshClient.post("/auth/refresh", {
      //   refreshToken: getAccessCookie("refreshToken")?.refreshToken,
      // });

      const res = await refreshClient.post("/auth/refresh");

      const { token, expiryToken, refreshToken, expiryRefreshToken } = res.data;

      setTokens({
        token,
        expiryToken,
        refreshToken,
        expiryRefreshToken,
      });

      return token; // note: return new access token
    })();

    return Promise.race([call, timeout]);
  }

  // note: get valid token.
  async function getValidToken() {
    // note: already refreshing? reuse same Promise.
    if (refreshPromise) {
      return refreshPromise;
    }

    // note: start refresh.
    refreshPromise = (async () => {
      try {
        const newToken = await doRefreshRequest();

        return newToken;
      } catch (err) {
        // note: hard logout on refresh failure.
        if (typeof onLogout === "function") {
          onLogout(err);
        }
        throw err;
      } finally {
        // note: SUPER IMPORTANT.
        // note: release the lock no matter success or fail.
        refreshPromise = null;
      }
    })();

    return refreshPromise;
  }

  return {
    getAccessToken,
    getValidToken, // note: triggers refresh if needed and returns new access token.
  };
}

// note: has valid access token.
export function hasValidAccessToken() {
  const t = getAccessCookie("token")?.token;

  if (!t) return false;

  // note: decode & check exp (no crypto verification, just UX).
  try {
    const [, payload] = t.split(".");
    const { exp } = JSON.parse(atob(payload));

    const now = Math.floor(Date.now() / 1000);
    // note: add small skew buffer.
    return exp && exp - 10 > now;
  } catch {
    return false;
  }
}
